import React from 'react';
import { Group, Rect, Line } from 'react-konva';

// «بازشو»: نشان‌دهنده تکه‌ای از دیوار که واقعاً دیوار نیست (مثلاً مرز باز بین پذیرایی و آشپزخانه) —
// نه در دارد نه پنجره، فقط دیوار را در طول خودش پاک می‌کند و با دو تیک کوتاه در دو سر و یک خط‌چین وسط
// نشان می‌دهد که مرز فضا همچنان همان‌جاست، فقط دیواری رویش نیست
function Bazsho({ x, y, length, angleDeg, thickness = 8, selected = false, onPointerDown }) {
  const color = selected ? '#0a66c2' : '#c7c7c7';

  return (
    <Group x={x} y={y} rotation={angleDeg} onPointerDown={onPointerDown}>
      {/* ناحیه نامرئی و بزرگ‌تر برای راحتی لمس روی موبایل */}
      <Rect x={-6} y={-thickness / 2 - 10} width={length + 12} height={thickness + 20} fill="#000000" opacity={0} />
      {/* پاک‌کردن بصری دیوار در طول بازشو — یعنی اینجا واقعاً دیواری نیست */}
      <Rect x={0} y={-thickness / 2} width={length} height={thickness} fill="#ffffff" />
      {/* دو تیک کوتاه عمود در دو سر بازشو، تا مرز فضا هنوز قابل تشخیص بماند */}
      <Line points={[0, -thickness / 2 - 5, 0, thickness / 2 + 5]} stroke={color} strokeWidth={selected ? 2 : 1.5} />
      <Line points={[length, -thickness / 2 - 5, length, thickness / 2 + 5]} stroke={color} strokeWidth={selected ? 2 : 1.5} />
      {/* خط‌چین وسط — نشانه مرز باز بین دو فضا */}
      <Line points={[0, 0, length, 0]} stroke={color} strokeWidth={selected ? 1.5 : 1} dash={[5, 5]} />
    </Group>
  );
}

export default Bazsho;